"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdoptyModal = void 0;
const i18n_1 = __importDefault(require("src/locales/settings/i18n"));
const Modal_1 = require("src/projects/Widget/mainDOM/Modal");
const TourStepComponentBase_1 = require("src/projects/Widget/shadowDOM/tours/TourStepComponentBase");
const Editor2Html_1 = __importDefault(require("src/utils/Editor2Html"));
class AdoptyModal extends TourStepComponentBase_1.TourStepComponentBase {
    constructor(data, settings) {
        console.log("[AdoptyModal.constructor]");
        super(data, settings);
    }
    createModal() {
        console.log("[AdoptyModal.createModal]");
        this.element = new Modal_1.Modal(this.shadowRoot, {
            header: this.data.data.title,
            content: (0, Editor2Html_1.default)(this.data.data.content),
            size: this.data.data.size,
            footer: this.footer,
            closeBtn: i18n_1.default.t("Close"),
            can_close: this.settings.isFinish || this.data.data.can_close,
            onClose: this.settings.demoMode ? () => { } : this.settings.onClose,
            modal_class: this.settings.demoMode ? "adopty-modal-constructor" : "",
        });
        this.container_element = this.element.container;
        return this;
    }
    updateItem(data) {
        console.log("[AdoptyModal.updateItem]");
        this.data = data;
        this.element.update({
            header: this.data.data.title,
            content: (0, Editor2Html_1.default)(this.data.data.content),
            can_close: this.data.data.can_close,
            size: this.data.data.size,
        });
    }
    createElements() {
        console.log("[AdoptyModal.createElements]");
        this.createFooter();
        this.createModal();
        this.shadowRoot.appendChild(this.container_element);
        if (this.overlayClass) {
            this.shadowRoot.appendChild(this.overlayClass.createOverlay());
        }
        this.bindEvents();
    }
}
exports.AdoptyModal = AdoptyModal;
